import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/monthChangeRule/page/v2', Object.assign({}, options, {
    params
  }));

export const getParkList = (params, options) =>
  request.get('/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0', Object.assign({}, options, {
    params
  }));

  export const getRegionList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/getRegionList/v2', Object.assign({}, options, {
    params
  }));

  export const getBuildingList = (params, options) =>
  request.get('/api/v4ward/car/property/getBuildingList', Object.assign({}, options, {
    params
  }));

  export const getRoomList = (params, options) =>
  request.get('/api/v4ward/car/property/getRoomList', Object.assign({}, options, {
    params
  }));
//车位新增
  export const spaceSave = (params, options) =>
  request.post('/api/v4ward/car/parking/space/save', params, options);

  //车位编辑
  export const spaceUpdate = (params, options) =>
  request.post('/api/v4ward/car/parking/space/update', params, options);
//车位详情
  export const spaceDetail= (params, options) =>
  request.get('/api/v4ward/car/parking/space/detail', Object.assign({}, options, {
    params
  }));
//车位分页
  export const spacePage = (params, options) =>
  request.get('/api/v4ward/car/parking/space/page', Object.assign({}, options, {
    params
  }));
//缴费详情
export const spaceFeeInfo = (params, options) =>
request.get('/api/v4ward/car/parking/space/feeInfo', Object.assign({}, options, {
  params
}));
//缴费金额计算
export const spaceCalculateFee = (params, options) =>
request.post('/api/v4ward/car/parking/space/calculateFee',  params, options);

//缴费金下单
export const spacePay = (params, options) =>
request.post('/api/v4ward/car/parking/space/pay',  params, options);
//缴费金下单查询
export const spacePayQuery = (params, options) =>
request.get('/api/v4ward/car/parking/space/pay/query',  Object.assign({}, options, {
  params
}));
//删除车位
export const spaceRemove = (params, options) =>
request.post('/api/v4ward/car/parking/space/remove', qs.stringify(params), options);
//固停车缴费记录
export const carparkingSpaceFeeDetailPage = (params, options) =>
request.get('/api/v4ward/car/carparkingSpaceFeeDetail/page',  Object.assign({}, options, {
  params
}));
export const carfeeruleAdd = (params, options) =>
request.post('/api/v4ward/carfeerule/add', params, options);

export const carfeeruleUpdate= (params, options) =>
request.post('/api/v4ward/carfeerule/update', params, options);

export const carfeeruleDetail = (params, options) =>
  request.get('/api/v4ward/carfeerule/detail', Object.assign({}, options, {
    params
  }));

  export const getCarfeerulePage = (params, options) =>
  request.get('/api/v4ward/carfeerule/page', Object.assign({}, options, {
    params
  }));

  export const remove = (params, options) =>
  request.post('/api/v4ward/carfeerule/remove', qs.stringify(params), options);



//车辆收费套餐列表


  export const getCarRuleList = (params, options) =>
  request.get('/api/v4ward/carfeerule/carRuleList', Object.assign({}, options, {
    params
  }));
  export const carfeerulediscountPage = (params, options) =>
  request.get('/api/v4ward/carfeerulediscount/page', Object.assign({}, options, {
    params
  }));
  export const carfeerulediscountDetail = (params, options) =>
  request.get('/api/v4ward/carfeerulediscount/detail', Object.assign({}, options, {
    params
  }));
  export const carRuleDiscountList = (params, options) =>
  request.get('/api/v4ward/carfeerulediscount/carRuleDiscountList', Object.assign({}, options, {
    params
  }));

  export const bestCarRuleDiscountList = (params, options) =>
  request.get('/api/v4ward/carfeerulediscount/best/carRuleDiscountList', Object.assign({}, options, {
    params
  }));
  export const carfeerulediscountAdd = (params, options) =>
  request.post('/api/v4ward/carfeerulediscount/add', params, options);
  export const carfeerulediscountUpdate = (params, options) =>
  request.post('/api/v4ward/carfeerulediscount/update', params, options);
  export const carfeerulediscountRemove = (params, options) =>
  request.post('/api/v4ward/carfeerulediscount/remove', qs.stringify(params), options);
//车位状态统计
  export const spaceStatusCount = (params, options) =>
  request.get('/api/v4ward/car/parking/space/status/count', Object.assign({}, options, {
    params
  }));

//车位退款
  export const spaceRefund= (params, options) =>
  request.post('/api/v4ward/car/parking/space/refund', params, options);

//申请断缴
export const breakApply = (params, options) =>
  request.post('/api/v4ward/car/parking/space/breakApply', params, options);

//申请断缴
export const approve = (params, options) =>
  request.post('/api/v4ward/car/parking/space/approve', params, options);
